import { render } from "./shout_panel.vue?vue&type=template&id=7897a31a"
import script from "./shout_panel.js?vue&type=script&lang=js"
export * from "./shout_panel.js?vue&type=script&lang=js"

import "./shout_panel.vue?vue&type=style&index=0&id=7897a31a&lang=scss"

import exportComponent from "/Users/lainsoykaf/repos/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__